import { render } from 'lit/html.js'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export class StateElement extends HTMLElement {

  constructor() {
    super()

    this.first = true

    this.render = debounce( () => {
      // Hook Before
      if ( this.praeRender ) {
        this.praeRender( this.first )
      }
      // Throttle Rendering with debounce
      render( this.template( this.state ), this, { eventContext: this } )
      // Hook After
      if ( this.postRender ) {
        this.postRender( this.first )
      }
      // First is done
      this.first = false
    } )

    this.props = {}
  }

  // -------------------
  // Default Attributes
  // -------------------
  static get observedAttributes() {
    return [ "id", "src", "hidden", "disabled" ]
  }

  attributeChangedCallback( name, oldVal, newVal ) {
    if ( oldVal != newVal ) {
      this.render()
    }
  }

  // --------------------------------------------------------
  // Update new values for attributes and keep old values
  // but reset available properties and overwrite attributes
  // --------------------------------------------------------
  set state( props = {} ) {

    const updates = isEqual( props, this.props ) == false

    this.props = Object.keys( props ).reduce( ( acc, cur ) => {
      if ( this.constructor && this.constructor.observedAttributes && this.constructor.observedAttributes.includes( cur ) ) {
        this.setAttribute( cur, props[ cur ] )
      } else if ( cur == "className" ) {
        this.className = props[ cur ]
      } else {
        acc[ cur ] = props[ cur ]
      }
      return acc
    }, {} )

    if ( updates ) this.render()
  }

  // ---------------------------------
  // Merge attributes and properties
  // which have been set explicitly
  // ---------------------------------
  get state() {
    const attribs = this.constructor.observedAttributes.reduce( ( acc, cur ) => {
      if ( this.hasAttribute( cur ) ) {
        acc[ cur ] = this.getAttribute( cur )
      }
      return acc
    }, {} )
    return { ...attribs, ...cloneDeep( this.props ) }
  }


}